import React from "react";

const ImageSourceCaption = ({ sourceText }) => {
    let caption = "Image Source: Unknown"
    if (sourceText) {
        caption = "Image Source: " + sourceText
    }
    return (
        <figcaption>
            {sourceText == "microsoft-copilot" ? (
                <span>AI generated image using <a href='https://copilot.microsoft.com/images/create' target='_blank'>Microsoft Copilot</a>.</span>
            ) : (
                (sourceText == "author") ? <span>Image Source: Prepared by Author</span> : caption
            )}
        </figcaption>
    )
};

export default ImageSourceCaption;